export enum ProductListItemType {
    Product = 'product',
    ProductTileBanner = 'product-tile-banner',
    ProductListBanner = 'product-list-banner',
    BannerSelectionBlock = 'banner-selection-block',
    CuratedPlpSlider = 'curated-plp-slider',
    BundleBoxPlpSlider = 'bundle-box-plp-slider',
}
